'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requireFeature = require('routes/helpers/requireFeature');

var _requireFeature2 = _interopRequireDefault(_requireFeature);

var _liveOnenter = require('features/Videos/sagas/live.onenter.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

exports.default = function (store, client) {
  return {
    path: '/live',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_liveOnenter.liveSellPageOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },

    // TODO: Digital team - Temporarily routing all traffic to trial
    indexRoute: {
      onEnter: function onEnter(nextState, replace) {
        return replace('/live/trial');
      }
    },

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, { component: require('containers/CmsPage/CmsPage').CmsPage });
      }, 'live');
    },

    getChildRoutes: function getChildRoutes(location, callback) {
      var bounceIfDisabled = (0, _requireFeature2.default)(store, client, 'classpass_live_trial', '/live');

      require.ensure([], function (require) {
        callback(null, [{ path: 'try', component: require('features/LiveSell/LiveSell').LiveSell }, { path: 'activate', component: require('containers/CmsPage/CmsPage').CmsPage }, { path: 'features', component: require('features/LiveSell/LiveFeatures').LiveFeatures }, { path: 'learn', component: require('containers/CmsPage/CmsPage').CmsPage }, { path: 'trial', component: require('containers/CmsPage/CmsPage').CmsPage, onEnter: bounceIfDisabled }, { path: 'waitlist', component: require('containers/Live/LiveWaitlist').LiveWaitlist }]);
      }, 'live');
    }
  };
};